import { AI_ASSISTANTS_FEATURE_FLAG } from '@/hooks/aiAssistants/useAiAssistantsAccess'
import {
  ROUTE_AI_ASSISTANT_CREATE,
  ROUTE_AI_ASSISTANT_DISTRIBUTION,
  ROUTE_AI_ASSISTANT_EDIT,
  ROUTE_AI_ASSISTANT_KNOWLEDGE,
  ROUTE_AI_ASSISTANT_PERSONALITY,
  ROUTE_AI_ASSISTANT_STARTER_QUESTIONS,
  ROUTE_AI_ASSISTANTS,
} from '@/router/routes/routeNames'

const AiAssistantsView = () =>
  import('@/components/ai_assistants/AiAssistantsView.vue')
const AiAssistantCreateView = () =>
  import('@/components/ai_assistants/AiAssistantCreateView.vue')
const AiAssistantEditView = () =>
  import('@/components/ai_assistants/AiAssistantEditView.vue')
const AiAssistantPersonalityView = () =>
  import('@/components/ai_assistants/tabs/AiAssistantPersonalityView.vue')
const AiAssistantKnowledgeView = () =>
  import('@/components/ai_assistants/tabs/AiAssistantKnowledgeView.vue')
const AiAssistantStarterQuestionsView = () =>
  import('@/components/ai_assistants/tabs/AiAssistantStarterQuestionsView.vue')
const AiAssistantDistributionView = () =>
  import('@/components/ai_assistants/tabs/AiAssistantDistributionView.vue')

// Both halves of the gate: the company flag (resource) and the user's accessible.
// Repeated on every child because the access check reads the leaf's meta.
// The flag records the customer's AI consent and the backend does not check it,
// so `requiredFeatureFlags` holds superadmins to it as well.
const aiAssistantsMeta = {
  resource: AI_ASSISTANTS_FEATURE_FLAG,
  requiredFeatureFlags: [AI_ASSISTANTS_FEATURE_FLAG],
  abacResource: 'ai_assistants',
  requiresAuth: true,
}

// `new` is declared before `:aiAssistantId` because routes match in order
const aiAssistantsRoutes = [
  {
    name: ROUTE_AI_ASSISTANTS,
    path: '/ai-assistants',
    component: AiAssistantsView,
    meta: aiAssistantsMeta,
  },
  {
    name: ROUTE_AI_ASSISTANT_CREATE,
    path: '/ai-assistants/new',
    component: AiAssistantCreateView,
    meta: aiAssistantsMeta,
  },
  {
    name: ROUTE_AI_ASSISTANT_EDIT,
    path: '/ai-assistants/:aiAssistantId',
    component: AiAssistantEditView,
    redirect: { name: ROUTE_AI_ASSISTANT_PERSONALITY },
    meta: aiAssistantsMeta,
    children: [
      {
        name: ROUTE_AI_ASSISTANT_PERSONALITY,
        path: 'personality',
        component: AiAssistantPersonalityView,
        meta: aiAssistantsMeta,
      },
      {
        name: ROUTE_AI_ASSISTANT_KNOWLEDGE,
        path: 'knowledge',
        component: AiAssistantKnowledgeView,
        meta: aiAssistantsMeta,
      },
      {
        name: ROUTE_AI_ASSISTANT_STARTER_QUESTIONS,
        path: 'starter-questions',
        component: AiAssistantStarterQuestionsView,
        meta: aiAssistantsMeta,
      },
      {
        name: ROUTE_AI_ASSISTANT_DISTRIBUTION,
        path: 'distribution',
        component: AiAssistantDistributionView,
        meta: aiAssistantsMeta,
      },
    ],
  },
]

export default aiAssistantsRoutes
